import { useMutation, useQueryClient } from '@tanstack/react-query';

import updateLead, {
  LeadResponse,
  UpdateLeadApiPayload,
} from '@/actions/leads/updateLead';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateLeadReturn {
  mutate: (
    payload: UpdateLeadApiPayload
  ) => Promise<ApiResponse<LeadResponse> | undefined>;
  result: ApiResponse<LeadResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useUpdateLead = (): UseUpdateLeadReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateLead,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['consultant-leads'] });
      queryClient.invalidateQueries({
        queryKey: ['lead-profile', variables.leadId],
      });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
